import React, {memo} from 'react';
import {
    FormValidationBorder,
    FormValidationCircle,
    FormValidationRoute,
    FormValidationSquare,
    RequestShiftData
} from "./request-shift-card.styles";
import {CustomTimePicker, SimpleTextInput, CustomDatePicker} from "../../core-ui";
import 'react-times/css/material/default.css';
import Num2persian from 'num2persian';

const RequestShiftCard = ({shiftTitle, shiftData, changeHandler, onDeleteShift, id}) => {
    return (
        <div className='mt-5' id={`req-sh-c-${id}`}>
            <div className='d-flex align-items-center justify-content-between'>
                <h5 className='success-color fw-normal'>شیفت {`${shiftTitle === 'یک' ? 'اول' : shiftTitle.replace('سه', 'سو')+'م'}`}</h5>
                {
                    id !== 0 &&
                    <button className='btn-text danger-color' onClick={onDeleteShift}>
                        <i className='icon-close-circle ms-2 align-middle'/>
                        حذف این شیفت
                    </button>
                }
            </div>

            <RequestShiftData>
                <div className='col-12 col-md-8 mx-auto'>
                    <div className='position-relative'>
                        <FormValidationRoute>
                            <FormValidationCircle active={shiftData.start_time}/>
                            <FormValidationBorder/>
                            <FormValidationSquare active={shiftData.end_time}/>
                        </FormValidationRoute>
                        <div className='row'>
                            <p className='d-block d-lg-none text-center'>از تاریخ:</p>
                            <div className='col-12 col-lg-6 rtl'>
                                <CustomDatePicker timePicker={false}
                                                  labelStyle='d-none d-lg-block text-end mb-2'
                                                  label='از تاریخ'
                                                  value={shiftData.start_date}
                                                  onChange={value => changeHandler('start_date', value, id)}/>
                            </div>
                            <div className='col-12 col-lg-6 mt-4 mt-lg-0'>
                                <CustomTimePicker
                                    label='از ساعت'
                                    labelStyle='d-none d-lg-block text-end mb-2'
                                    withoutIcon
                                    theme="material"
                                    time={shiftData.start_time}
                                    onTimeChange={value => changeHandler('start_time', value, id, true)}
                                />
                            </div>
                        </div>
                        <div className='row mt-5 mt-c-lg-5'>
                            <p className='d-block d-lg-none text-center'>تا تاریخ:</p>
                            <div className='col-12 col-lg-6'>
                                <CustomDatePicker timePicker={false}
                                                  labelStyle='d-none d-lg-block text-end mb-2'
                                                  onChange={value => changeHandler('end_date', value, id)}
                                                  value={shiftData.end_date}
                                                  label='تا تاریخ'/>
                            </div>
                            <div className='col-12 col-lg-6 mt-4 mt-lg-0'>
                                <CustomTimePicker
                                    labelStyle='d-none d-lg-block text-end mb-2'
                                    label='تا ساعت'
                                    withoutIcon
                                    theme="material"
                                    time={shiftData.end_time}
                                    onTimeChange={value => changeHandler('end_time', value, id, true)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className='row mt-c-5'>
                        <div className='col-12 col-lg-6'>
                            <SimpleTextInput className='bg-transparent'
                                             style={{paddingRight: '3.3rem'}}
                                             icon={<i className='icon-dollar-square' />}
                                             value={shiftData.earning}
                                             onChange={({target: {value}}) => changeHandler('earning', value, id)}
                                             label='هزینه شیفت'
                                             placeholder='600,000'/>
                            <p className='mb-0 mt-2 mt-lg-3 me-5 me-lg-3 sky-color fs-c-5'>
                                {Num2persian(shiftData.earning ? shiftData.earning : '600000')} تومان</p>
                        </div>
                        <div className='col-12 col-lg-6 mt-4 mt-lg-0'>
                            <CustomDatePicker timePicker={false}
                                              // labelStyle='d-none d-lg-block text-end mb-2'
                                              value={shiftData.settlement_date}
                                              onChange={value => changeHandler('settlement_date', value, id)}
                                              label='تاریخ پرداخت هزینه'/>
                        </div>
                    </div>
                </div>
            </RequestShiftData>
        </div>
    );
};

function RequestShiftCard2(props, nexProps) {
    return JSON.stringify(props) === JSON.stringify(nexProps);
}

export default memo(RequestShiftCard, RequestShiftCard2);
